import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = (state: RootState) => state.userBlock

export const selectIsConfirmBlockModalOpen = createSelector(
    baseSelector,
    (state) => state.isConfirmModalOpen
)

export const selectCurrentUser = createSelector(
    baseSelector,
    (state) => state.currentUser
)

export const selectBlockAction = createSelector(
    baseSelector,
    (state) => state.action
)

export const selectOnSuccess = createSelector(
    baseSelector,
    (state) => state.onSuccess
)
